export enum GendersEnum {
  M = 'Muž',
  F = 'Žena',
}
